import { REQUIRED_TEXT_FIELD_VALIDATOR, STRING_VALIDATOR, TEXT_MAX_LENGTH } from '@/helpers/formHelpers/validators';
import { boolean, object } from 'yup';

const MAX_LENGTH_MESSAGE = 'Max length = 255 chars.';

export const CONFIRM_MASTER_AGREEMENT_VALIDATOR = boolean().oneOf([true], 'You must accept Master Service Agreement');

export const MASTER_SERVICE_AGREEMENT_VALIDATION_SCHEMA = object().shape({
  first_name: REQUIRED_TEXT_FIELD_VALIDATOR.max(TEXT_MAX_LENGTH, MAX_LENGTH_MESSAGE),
  middle_name: STRING_VALIDATOR.max(TEXT_MAX_LENGTH, MAX_LENGTH_MESSAGE).trim(),
  last_name: REQUIRED_TEXT_FIELD_VALIDATOR.max(TEXT_MAX_LENGTH, MAX_LENGTH_MESSAGE),
  confirmed_agreement: CONFIRM_MASTER_AGREEMENT_VALIDATOR,
});
